import axios from "axios"
import ChartingOption from "../models/LookUp/ChartingOption"
import Color from "../models/LookUp/Color"
import EngraveFontOption from "../models/LookUp/EngraveFontOption"
import EngravingOption from "../models/LookUp/EngravingOption"
import KeyCodeBucketType from "../models/LookUp/KeyCodeBucketType"
import KeyOption from "../models/LookUp/KeyOption"
import LockMaterial from "../models/LookUp/LockMaterial"
import LockMaterialDependency from "../models/LookUp/LockMaterialDependency"
import ShackleType from "../models/LookUp/ShackleType"
import SalesArea from "../models/LookUp/SalesArea"
import { API_BASE_URL, getAxiosRequestConfig, getGuestConfig } from "./apiBase";


const getLookupUrl = (lookupType: string, isOktaAuthenticated: boolean): string => {
  return isOktaAuthenticated ? `LookUp/${lookupType}` : `View/lookup/${lookupType}`
}
const getLookupConfig = (bearerToken: string, isOktaAuthenticated: boolean) => {
  return isOktaAuthenticated ? getAxiosRequestConfig(bearerToken) : getGuestConfig(bearerToken)
}

/**
 * 
 * @param bearerToken 
 * @returns 
 */
export const lookUpColors = async (bearerToken: string, isOktaAuthenticated: boolean): Promise<Color[]> => {
  const response = await axios.get<Color[]>(getLookupUrl('colors', isOktaAuthenticated), getLookupConfig(bearerToken, isOktaAuthenticated))
  return response.data
}

/**
 * @deprecated
 */
export const lookUpEngravingOptions = async (bearerToken: string): Promise<EngravingOption[]> => {
  const response = await axios.get<EngravingOption[]>(`LookUp/engravingOptions`, getAxiosRequestConfig(bearerToken))
  return response.data
}

export const lookUpKeyOptions = async (bearerToken: string, isOktaAuthenticated: boolean): Promise<KeyOption[]> => {
  const config = isOktaAuthenticated ? getAxiosRequestConfig(bearerToken) : getGuestConfig(bearerToken)
  const response = await axios.get<KeyOption[]>(getLookupUrl('keyOptions',isOktaAuthenticated), getLookupConfig(bearerToken, isOktaAuthenticated))
  return response.data
}

/**
 * @deprecated
 */
export const lookUpChartingOptions = async (bearerToken: string): Promise<ChartingOption[]> => {
  const response = await axios.get<ChartingOption[]>(`LookUp/chartingOptions`, getAxiosRequestConfig(bearerToken))
  return response.data
}

export const lookUpLockMaterials = async (bearerToken: string, isOktaAuthenticated: boolean): Promise<LockMaterial[]> => {
  const response = await axios.get<LockMaterial[]>(getLookupUrl('lockMaterials',isOktaAuthenticated), getLookupConfig(bearerToken, isOktaAuthenticated))
  return response.data
}

export const lookUpShackleTypes = async (bearerToken: string, isOktaAuthenticated: boolean): Promise<ShackleType[]> => {
  const response = await axios.get<ShackleType[]>(getLookupUrl('shackleTypes',isOktaAuthenticated), getLookupConfig(bearerToken, isOktaAuthenticated))
  return response.data
}

export const lookUpLockMaterialDependencies = async (bearerToken: string, isOktaAuthenticated: boolean): Promise<LockMaterialDependency[]> => {
  const response = await axios.get<LockMaterialDependency[]>(getLookupUrl('lockmaterialdependencies',isOktaAuthenticated), getLookupConfig(bearerToken, isOktaAuthenticated))
  return response.data
}

export const lookUpEngraveFontOptions = async (bearerToken: string, isOktaAuthenticated: boolean): Promise<EngraveFontOption[]> => {
  const response = await axios.get<EngraveFontOption[]>(getLookupUrl('engravefontoptions',isOktaAuthenticated), getLookupConfig(bearerToken, isOktaAuthenticated))
  return response.data
}

export const lookUpKeyCodeBucketTypes = async (bearerToken: string, isOktaAuthenticated: boolean): Promise<KeyCodeBucketType[]> => {
  const response = await axios.get<KeyCodeBucketType[]>(getLookupUrl('keycodebuckettype',isOktaAuthenticated), getLookupConfig(bearerToken, isOktaAuthenticated))
  return response.data
}

export const lookUpSalesAreas = async (bearerToken: string, isOktaAuthenticated: boolean): Promise<SalesArea[]> => {
  const response = await axios.get<SalesArea[]>(getLookupUrl('salesareas',isOktaAuthenticated), getLookupConfig(bearerToken, isOktaAuthenticated))
  return response.data
}